import { GlobalAxios } from "../axios/axios-config";
import {
  IProfileTicketDefaultDocCategoriesPayload,
  IProfileTicketDefaultDocCategory,
} from "../models/profile-ticket-default-doc-category";
import { ISearchParams, ISearchReturn } from "../models/requests";
import MainApi from "./mainApi.service";

const PROFILE_TICKET_DEFAULT_DOC_CATEGORIES_ROUTE =
  process.env.REACT_APP_IDENTIY +
  "/api/v1/ProfileTicketDefaultDocCategories/";

export type IProfileTicketDefaultDocCategoriesSearchParams = ISearchParams & {
  RoleId?: string;
};

export const getProfileTicketDefaultDocCategories = (
  params?: IProfileTicketDefaultDocCategoriesSearchParams
) => {
  return GlobalAxios.get<ISearchReturn<IProfileTicketDefaultDocCategory>>(
    PROFILE_TICKET_DEFAULT_DOC_CATEGORIES_ROUTE,
    {
      params,
    }
  );
};

export const createProfileTicketDefaultDocCategories = (
  item: IProfileTicketDefaultDocCategoriesPayload
) => {
  return GlobalAxios.post(PROFILE_TICKET_DEFAULT_DOC_CATEGORIES_ROUTE, item);
};

export const updateProfileTicketDefaultDocCategories = ({
  id,
  item,
}: {
  id: string;
  item: IProfileTicketDefaultDocCategoriesPayload;
}) => {
  return GlobalAxios.put(PROFILE_TICKET_DEFAULT_DOC_CATEGORIES_ROUTE + id, item);
};

export const deleteProfileTicketDefaultDocCategory = (id: string) => {
  return GlobalAxios.delete(PROFILE_TICKET_DEFAULT_DOC_CATEGORIES_ROUTE + id);
};

export class ProfileTicketDefaultDocCategoriesService extends MainApi<IProfileTicketDefaultDocCategory> {
  constructor() {
    super(PROFILE_TICKET_DEFAULT_DOC_CATEGORIES_ROUTE);
  }

  deleteItemById = (id: string) => deleteProfileTicketDefaultDocCategory(id);
}
